import Scriba from 'react-scriba';

export class DataOperation {
    static _onEnregistrementElementsContratReservation(operation) {
        let objet = {
            "operation": operation
        };

        var url = "api/MAJDonnees/EnregistrementElementsContratReservation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementOperation = (operation, listOperationTVACas) => {
        const objet = { operation, listOperationTVACas };
        const url = "api/MAJDonnees/EnregistrementOperation";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementOperationPerimetreAdministrative(idRegionAdministrative, idDepartementAdministratif, idVilleAdministrative, filtreSurMonPerimetre) {
        const objet = { idRegionAdministrative, idDepartementAdministratif, idVilleAdministrative, filtreSurMonPerimetre };
        const url = "api/Liste/ListeDesOPERATIONSParPerimetreAdministratif";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementOperationPerimetreEiffage = (idProduit, idRegion, idAgence, idProgramme, filtreSurMonPerimetre) => {
        const objet = { idProduit, idRegion, idAgence, idProgramme, filtreSurMonPerimetre };
        const url = "api/Liste/ListeDesOPERATIONSParPerimetreEiffage";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementFicheIdentification = () => {
        const objet = {};
        const url = "api/Fiche/FicheIdentification_Operation";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementFicheIdentificationProgramme() {
        /* 20230223 : YD : injection dependance Agence */
        let url = "api/v2/Fiche/FicheIdentification_Programme";
        var paramPost = Scriba.fetch().createParameterPost();

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheIdentificationPlanning = () => {
        const url = "api/Fiche/FicheIdentification_Planning";
        const paramPost = Scriba.fetch().createParameterPost();
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementOperations(filtres, tri, filtreIdStatut) {
        let objet = { filtres, tri };

        //AF pour tableau de bord --> on force l'id du statut
        if (filtreIdStatut !== undefined) {
            objet["filtreIdStatut"] = filtreIdStatut;
        }

        var url = "api/Liste/ListeDesOPERATIONS";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementCreerAPartirDe(idOperation) {
        let objet = {
            "idOperation": idOperation
        };

        var url = "api/MAJDonnees/EnregistrementCreerAPartirDe";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());

    }

    static _chargementOperation(idOperation) {
        let objet = {
            "idOperation": idOperation
        };

        var url = "api/Get/ChargementOperation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheOperation(idOperation) {
        let objet = {
            "idOperation": idOperation
        };

        var url = "api/Fiche/FicheOperation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheOperation_PhotoTailleReelle(rowGUID) {
        let objet = {
            "rowGUID": rowGUID
        };

        var url = "api/Fiche/FicheOperation_PhotoTailleReelle";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheOperation_DocumentsLot(idOperation, idLot) {
        let objet = {
            "idOperation": idOperation,
            "idLot": idLot
        };

        var url = "api/Fiche/FicheOperation_DocumentsLot";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheOperation_Photos(idOperation) {
        let objet = {
            "idOperation": idOperation,
        };

        var url = "api/Fiche/FicheOperation_Photos";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheOperation_DocumentsOperation(idOperation) {
        let objet = {
            "idOperation": idOperation
        };

        var url = "api/Fiche/FicheOperation_DocumentsOperation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheIdentification_CycleOperation(idOperation) {

        let objet = {
            "idOperation": idOperation
        };

        var url = "api/Fiche/FicheIdentification_CycleOperation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheIdentification_CycleOperationParProgramme(programme) {

        let objet = {
            "idProgramme": programme.idProgramme,
            "idRegion": programme.idRegion,
            "idAgence": programme.idAgence,
        };

        var url = "api/Fiche/FicheIdentification_CycleOperationParProgramme";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheIdentification_CycleCommercial(idOperation) {

        let objet = {
            "idOperation": idOperation
        };

        var url = "api/Fiche/FicheIdentification_CycleCommercial";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementImportExport = () => {
        const url = "api/Liste/ListeImportExport";
        const paramPost = Scriba.fetch().createParameterPost();
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementGrilleDePrix(filtreIdLotType, filtreStatut, filtreNumLot, filtreSHA, filtreEtage, filtreExposition, filtreBudget) {
        let objet = {
            "filtreIdLotType": filtreIdLotType,
            "filtreStatut": filtreStatut,
            "filtreNumLot": filtreNumLot,
            "filtreSHA": filtreSHA,
            "filtreEtage": filtreEtage,
            "filtreExposition": filtreExposition,
            "filtreBudget": filtreBudget
        };

        var url = "api/Liste/ListeGrilleDePrix";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementPlanningIdentification(operation, listOperationTVACas) {
        const objet = { operation, listOperationTVACas };
        var url = "api/MAJDonnees/EnregistrementPlanningIdentification";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());

    }

    // KP - 2559 - 29/01/2024 : n'est plus utilisée
    //static _onEnregistrementIntervenant(idOperation, idIntervenant, estPersonne) {
    //    let objet = {
    //        "idOperation": idOperation,
    //        "idIntervenant": idIntervenant,
    //        "estPersonne": estPersonne
    //    };

    //    var url = "api/MAJDonnees/EnregistrementIntervenant";
    //    var paramPost = Scriba.fetch().createParameterPost(objet);

    //    return fetch(url, paramPost).then(response => response.json());
    //}

    // KP - 2559 - 29/01/2024 : n'est plus utilisée
    //static _onSuppressionIntervenants(idOperation, intervenants) {
    //    let objet = {
    //        "idOperation": idOperation,
    //        "intervenants": intervenants
    //    };

    //    var url = "api/MAJDonnees/SuppressionIntervenants";
    //    var paramPost = Scriba.fetch().createParameterPost(objet);

    //    return fetch(url, paramPost).then(response => response.json());
    //}

    static _getOperation() {
        let objet = {};

        var url = "api/Get/GetOperation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementMandatCommercialisation(idOperation, tri) {
        let objet = { idOperation, tri };

        var url = "api/Liste/GetMandatCommercialisation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementOperationsDatesPrevisionnellesPassees(idOperation) {
        let objet = { idOperation };

        var url = "api/Liste/ListeOperationsDatesPrevisionnellesPassees";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementSocietesCommercialisantes(idOperation, idReservation) {
        const objet = { idOperation, idReservation };
        const url = "api/Get/GetSocietesCommercialisantes";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementComptesCommercialisants(idOperation, idSociete) {
        const objet = { idOperation, idSociete };
        const url = "api/Get/GetComptesCommercialisants";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementOperationEtLotCommercial(idOperation, idReservation) {
        const objet = { idOperation, idReservation };
        const url = "api/Get/GetOperationEtLotCommercial";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    }

}